import React from 'react'
import member1 from '../assets/images/member1.jpg'
import member2 from '../assets/images/member2.jpg'
import member3 from '../assets/images/member3.jpg'
import member4 from '../assets/images/member4.jpg'
import member5 from '../assets/images/member5.jpg'
import member6 from '../assets/images/member6.jpg'
import member7 from '../assets/images/imgn_7.jpg'

import member8 from '../assets/images/Member8.svg'





const IveyTeam = () => {

    const teamMembers = [
        {
            name: "Kirk Ivy",
            role: "Founder and Principal",
            img: member1,
        },
        {
            name: "Dariangela Albornoz",
            role: "Field Coordinator ",
            img: member2,
        },
        {
            name: "Natalie Valdes",
            role: "Office administration",
            img: member3,
        },
        // {
        //     name: "Diana Reyes",
        //     role: "Project Coordinator",
        //     img: member4,
        // },
        // {
        //     name: "Daniel Nino",
        //     role: "Estimator Architect",
        //     img: member5,
        // },
        // {
        //     name: "Tatiana Castrillon",
        //     role: "Business Development",
        //     img: member6,
        // },
          {
            name: "Dana Timmer",
            role: "Project Manager",
            img: member7,
        },
         {
            name: "Evelio Luis",
            role: "Field Quality Controlle",
            img: member8,
        },
    ];

    return (
        <>
            <div className='ivey-team-setion bg-black color-light py-120'>
                <div className='container'>
                    <div className='heading-block pb-80'>
                        <h6 className='font-12 fw-600 text-uppercase text-white'>THE IVEY TEAM</h6>
                    </div>
                    <div className='team-blocks'>
                        <div className='team-members d-grid column-3 gap-20 d-gap-40 row-gap-50'>
                            {teamMembers.map((member, idx) => (
                                <div className='team-member d-flex gap-20 align-center'>
                                    <div className='member-image'>
                                        <img src={member.img} className='cover grayscale-img' />
                                    </div>
                                    <div className='member-info'>
                                        <div className='name font-16 fw-100 mb-5'>{member.name}</div>
                                        <div className='role font-12 fw-400'>{member.role}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IveyTeam